import "./Contact.module.css";
import Hoofdmenu from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import ContactEnWerkgebied from "./sections/ContactEnWerkgebied";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Hoofdmenu />
      <Contact />
      <ContactEnWerkgebied />
      <Footer />
    </div>;
}